import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../hooks';

export const useCustomNavigate = () => {
  const navigate = useNavigate();
  const isMigrated = useAppSelector((state) => state?.isMigrated?.isMigrated);
  const queryParam = useAppSelector((state) => state?.isMigrated?.queryParam);

  const customNavigate = (path: string | number, options?: { replace?: boolean ; state?: any }) => {
    if (typeof path === 'number') {
        navigate(path);
      } else {
      let fullPath = path;
      localStorage.setItem("prevPath",window?.location.pathname);
      if (isMigrated && queryParam) {
        fullPath += fullPath.includes('?') ? `&${queryParam}` : `?${queryParam}`;
      }
        navigate(fullPath, options);
      }
    };

  return { customNavigate };
};